<template>
  <form
    v-on:submit.prevent="onSubmit"
    class="form-unit">
    <input-text
      class="form-unit__input"
      placeholder="Наименование"
      title="Наименование"
      v-bind:maxlength="200"
      v-bind:violations="nameInputErrors"
      v-letter-capital
      v-model="name" />
    <input-text
      class="form-unit__input"
      placeholder="Краткое наименование"
      title="Краткое наименование"
      v-bind:maxlength="200"
      v-bind:violations="shortNameInputErrors"
      v-letter-capital
      v-model="shortName" />
    <textarea-length-limitation
      class="form-unit__input"
      placeholder="Комментарий"
      title="Комментарий"
      show-counter
      v-bind:rows="3"
      v-bind:max-length="1000"
      v-letter-capital
      v-bind:violations="noteInputErrors"
      v-model="note" />
    <div class="form-unit__buttons">
      <button
        class="form-unit__button-cancel"
        type="button"
        v-on:click="onClose">Отмена</button>
      <button
        class="form-unit__button-save"
        type="submit"
        v-bind:disabled="isAwaitRequest">
        {{ this.isEdit ? "Сохранить" : "Создать" }}
      </button>
    </div>
  </form>
</template>

<script>
import InputText from '@/components/InputText.vue';
import { ProductUnitRequest } from '@/storage/gateways/ProductGateway';
import TextareaLengthLimitation from '@/components/TextareaLengthLimitation.vue';

/**
 * @description Название события подтверждения.
 * @type {string}
 */
const NAME_EVENT_SUBMIT = 'submit';

/**
 * @description Название события закрытия.
 * @type {string}
 */
const NAME_EVENT_CLOSE = 'close';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

/**
 * @description Форма единицы измерения товара.
 * @returns {Vue}
 */
export default {
  name: 'FormProductUnit',
  components: { TextareaLengthLimitation, InputText },
  computed: {
    nameInputErrors: resolveInputErrors('unit.name'),
    shortNameInputErrors: resolveInputErrors('unit.short-name'),
    noteInputErrors: resolveInputErrors('unit.note'),
    /**
     * @description Редактируется.
     * @returns {boolean}
     */
    isEdit() {
      return this.unitId !== '';
    },
  },
  data() {
    return {
      name: this.initialName,
      shortName: this.initialShortName,
      note: this.initialNote,
    };
  },
  methods: {
    /**
     * @description Обработать закрытие формы.
     * @returns {void}
     */
    onClose() {
      this.$emit(NAME_EVENT_CLOSE);
    },
    /**
     * @description Обработать отправку формы.
     * @returns {void}
     */
    onSubmit() {
      const request = this.makeRequest();
      this.$emit(NAME_EVENT_SUBMIT, request);
    },
    /**
     * @description Создать запрос.
     * @returns {ProductUnitRequest}
     */
    makeRequest() {
      return new ProductUnitRequest(
        this.unitId ?? null,
        this.name,
        this.shortName,
        this.note,
      );
    },
  },
  props: {
    /**
     * @description Идентификатор единицы измерения.
     */
    unitId: { type: String, default: () => '' },
    /**
     * @description Начальное наименование.
     */
    initialName: { type: String, default: () => '' },
    /**
     * @description Начальное краткое наименование.
     */
    initialShortName: { type: String, default: () => '' },
    /**
     * @description Начальный комментарий.
     */
    initialNote: { type: String, default: () => '' },
    /**
     * @description Нарушения ограничений.
     * @type {any}
     */
    inputErrors: { type: Object, required: true },
    /**
     * @description Ожидание выполнения запроса.
     * @type {Boolean}
     */
    isAwaitRequest: { type: Boolean, default: false },
  },
};
</script>

<style scoped lang="scss">
  @use "@/scss/buttons";

.form-unit {
  display: grid;
  row-gap: 20px;
  &__buttons {
    display: grid;
    grid-template-columns: repeat(2, minmax(100px, 214px));
    justify-content: end;
    gap: 10px;
  }
  &__button-cancel {
    @include buttons.btn-transparent(100%, 48px, 16px);
  }
  &__button-save {
    @include buttons.btn-blue(100%, 48px, 16px);
  }
}

@media screen and (max-width: 400px) {
 .form-unit {
  &__buttons {
    grid-template-columns: 1fr;
  }
 }
}
</style>
